















import { Component, Vue, Prop } from 'vue-property-decorator'

import { Colors, Sides } from '@/utils/constants'

@Component({ name: 'TeamBoard', components: {} })
export default class MyComponent extends Vue {
  @Prop({ default: Colors.RED }) private color!: Colors

  @Prop({ default: 'Team' }) private name!: string

  @Prop({ default: Sides.LEFT }) private side!: Sides

  @Prop({ default: 0 }) private score!: number

  get isLeft() {
    return this.side === Sides.LEFT
  }

  get bgClass() {
    return `bg-${this.color}-500 border-${this.color}-800 `
  }

  get scoreClass() {
    return `p-5 border-l-2 border-r-2 border-${this.color}-800`
  }
}
